import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "BusinessType",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemList",
  "GetItemById",
  'GetItemByBusinessTypeId',
  "FindByConditions",
  "FindAll",
  "GetPageContentByConditions"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const BusinessTypeApi = ZJApi.defineNewApi("BusinessTypeApi", factory);

export default BusinessTypeApi;
